export const USERS = `
query users(
  $filter:  FilterUserInput,
  $orderBy:  UserOrderInput,
  $searchText: String,
  $skip: Int,
  $take: Int
) {
  users(
    filter: $filter
    orderBy: $orderBy
    searchText:$searchText      
    skip: $skip
    take: $take
  ) {
    __typename
    ... on User {
      id
      email
      firstname
      lastname
      lastAccess
      status      
      is_system_user
      user_role{
        role{
          name
          id
        }
      }
      profile{
        id
        phone
        timezone
        date_format
        date_time_format
      }
      profile_picture_id
      two_factor_auth_active
      signature_id
      validated
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const LOGIN = `mutation login($email: String!, $password: String!) {
  login(
    email: $email, password: $password
  ) 
  {
    __typename
    ...on Auth {
      token
      user {
        id
        two_factor_auth_active
        last_tenant_id
        user_role{
          role{
            name
            is_system_role
          }
        }
      }
    }
    ...on ResponseMessage {
      status
      response
    }
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
    ...on ApiLoginResponse {
      token
    }
  }
}
`;

export const LOGIN_FIREBASE = `mutation loginFirebase($uid: String!) {
  loginFirebase(
    uid: $uid
  ) 
  {
    __typename
    ...on Auth {
      token
      user {
        id
      }
    }
    ...on ResponseMessage {
      status
      response
    }
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const AUTH = `
query authenticate($tenant_id:Int) {
  authenticate(tenant_id:$tenant_id) {
    __typename
    ... on AuthOutput {
      id
      firstname
      lastname
      email
      roles {
        id
        name
      }
      permissions 
			profile_id
      profile{
        id
        phone
        timezone
        date_format
        date_time_format
      }
      uid
      profile_picture_id
      two_factor_auth_active
      signature_id
      validated
      last_tenant_id
    }
  ...on ResultError {
    status_code
    message
    message_translation_key
  }
  }
}
`;

export const LOGOUT = `
query logout{
  logout{
    __typename
    ... on BooleanResult{
      result
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const RESET_PASSWORD = `
  query resetPassword($username: String!) {
    __typename
    resetPassword(input: { username: $username }) {
      __typename
      result
    }
  }
`;

export const VERIFY_RECOVERY_PASSWORD_TOKEN = `
query verifyRecoveryPasswordToken($token: String!){
  verifyRecoveryPasswordToken(
    token: $token
  ){
    __typename
    ...on RecoveryResult{
      result
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const USERS_COUNT = `
query userCount{
  userCount{
    __typename
    ... on UserCount{
      count
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const GET_PROFILE_PICTURE = `
query getProfilePicture(
  $id:  Int!
){
  getProfilePicture(
    id: $id
  ){
    __typename
    ...on ProfilePicture{
      id
      filename
      mimetype
      encoding
      file
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
export const GET_PROFILE_FILE = `
query getProfileFile(
  $id: Int!
){
  getProfileFile(
    id: $id,
  )
  {
    __typename
    ...on BaseFile{
      filename
      mimetype
      encoding
      file
        }
    ...on ResultError
    {
      status_code
      message
      message_translation_key
    }
  }
  }
`;

export const USER_COUNT_TO_INDICATOR = `
query userCountToIndicator($filter:FilterUserInput!){
  userCountToIndicator(filter:$filter) {
    __typename
    ... on  UserCount{
      count
    }
  ...on ResultError {
    status_code
    message
    message_translation_key
  }
}
}
`;
